import { MatDialogRef } from '@angular/material/dialog';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-biometry',
  templateUrl: './biometry.component.html',
  styleUrls: ['./biometry.component.scss']
})
export class BiometryComponent implements OnInit {

  @ViewChild('video', { static: true }) videoElement: ElementRef;
  @ViewChild('canvas', { static: true }) canvas: ElementRef;

  validating = false;
  videoWidth = 0;
  videoHeight = 0;
  captureStarted: boolean;

  constraints = {
    video: {
      width: { ideal: 320 },
      height: { ideal: 240 }
    }
  };

  constructor(
    private _dialog: MatDialogRef<BiometryComponent>,
    private _renderer: Renderer2,
    private _toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.enableCamera();
    this._checkPermission();
  }

  cancel(): void {
    this.stopCameraVideo();
    this._dialog.close(false);
  }

  enableCamera() {
    this.startCamera(this.constraints);
  }

  async stopCameraVideo() {
    await this.videoElement.nativeElement.pause();
    await this.releaseCamera();
  }

  async releaseCamera() {
    await this.videoElement.nativeElement.srcObject.getVideoTracks().forEach(track => { track.stop() })
  }

  async startCamera(localConstraints: any) {

    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
      const stream = await navigator.mediaDevices.getUserMedia(localConstraints);
      this.attachVideo(stream);
    } else {
      alert('Sorry, camera not available.');
    }
  }

  attachVideo(stream) {
    this._renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);

    this._renderer.listen(this.videoElement.nativeElement, 'play', (_) => {
      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
    });
    this.captureStarted = true;
  }

  capture() {
    this.validating = true;
    this._renderer.setProperty(this.canvas.nativeElement, 'width', this.videoWidth);
    this._renderer.setProperty(this.canvas.nativeElement, 'height', this.videoHeight);
    this.canvas.nativeElement.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
    const img = this.canvas.nativeElement.toDataURL('image/jpeg');
    this.stopCameraVideo();
    const imgData = img.replace(/^data:image\/[a-z]+;base64,/, "");
    this._dialog.close(imgData);
  }

  private _checkPermission(): void {
    let checking = ["audioinput", "videoinput"];
    let onlyHas = [];
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        let haveAllDevices = true;
        devices.forEach((device) => {
          onlyHas.push(device.kind);
          if (!(device.kind == checking[0] || device.kind == checking[1])) {
            haveAllDevices = false;
          }
        });
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
      });
  }
}
